import { render, staticRenderFns } from "./InsightsEmptyState.vue?vue&type=template&id=2ec36e70"
import script from "./InsightsEmptyState.vue?vue&type=script&lang=js"
export * from "./InsightsEmptyState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports